export class DateTime {
    static serverTimeDifference: number;
    static init(): void {
        const body = document.getElementById("body");
        const attValue = body.getAttribute("data-now");
        const serverDate = new Date(attValue);
        const clientDate = new Date();
        const difference = serverDate.getTime() - clientDate.getTime();
        const threshold = 3 * 60 * 1000;

        DateTime.serverTimeDifference = difference - (difference % threshold);
    }
    static now(): Date {
        const clientDate = new Date();
        const difference = clientDate.getTime() + DateTime.serverTimeDifference;
        const now = new Date(difference);

        return now;
    }
}
